'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('InterventionCtrl', InterventionCtrl);

  InterventionCtrl.$inject = ['$stateParams', '$location', 'activityRouter', 'user', 'windowSvc'];

  /* @ngInject */
  function InterventionCtrl($stateParams, $location, activityRouter, user, windowSvc) {
    var vm = this;
    var redirectUrl = $location.search() && $location.search().redirecturl ? $location.search().redirecturl : null;
    vm.title = 'InterventionCtrl';
    vm.tag = $stateParams.tag;
    vm.user = user;
    vm.navigateAction = function (activity) {
      activityRouter.createTrain(activity, {
        navigateFn: activityRouter.navigateDefault,
        params: {}
      }, false);
    };
    vm.skipIntervention = function () {
      if (redirectUrl) {
        var _redirect = windowSvc.getFullyQualifiedRedirectUrl(redirectUrl);
        windowSvc.windowNavigate(_redirect);
      } else {
        windowSvc.windowNavigate('/v/');
      }
    };
  }
})();